export function getColorMatrix(color: string): string {
  const hex = color.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16) / 255;
  const g = parseInt(hex.substring(2, 4), 16) / 255;
  const b = parseInt(hex.substring(4, 6), 16) / 255;
  return `${r} 0 0 0 0 0 ${g} 0 0 0 0 0 ${b} 0 0 0 0 0 1 0`;
}

export function powColorMatrix(color: string, pow: number): string {
  return getColorMatrix(color)
    .split(' ')
    .map((defaultValue) => (parseFloat(defaultValue) ** pow).toString())
    .join(' ');
}
